import { useMicrophoneStore } from '@/stores/microphone';
import { useSocketStore } from '@/stores/socket';

export default function useMicControl() {
  const socketStore = useSocketStore();
  const microphoneStore = useMicrophoneStore();

  const startMic = async () => {
    if (!microphoneStore.isMicOn) {
      socketStore.dispatchMessage('ah');
      microphoneStore.initMicEvent(sendAudioChunk);
      await microphoneStore.startMic(microphoneStore.selectedMicrophone.id);
    }
  };

  const stopMic = async () => {
    if (microphoneStore.isMicOn) {
      socketStore.dispatchMessage('ac');
      await microphoneStore.stopMic();
    }
  };

  const sendAudioChunk = (data) => {
    const audioBytes = new Float32Array(data);
    socketStore.sendMessageAudioStreamChunk(new Uint8Array(audioBytes.buffer), 'as');
  };

  return {
    sendAudioChunk,
    startMic,
    stopMic,
  };
}
